// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sWzg3ezL4sh_FHaP8dHq{width:100%;display:flex;align-items:flex-start;gap:4px;align-self:stretch}.bisPJ0cbjlfv70vIBtVW{width:64px}.u8QAxd9cwMIXBmzZv9Zz{margin:0}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Schedule/ui/ScheduleDelay/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,YAAA,CACA,sBAAA,CACA,OAAA,CACA,kBAAA,CAEF,sBACE,UAAA,CAGF,sBACE,QAAA","sourcesContent":[".wrap {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n}\n.input {\n  width: 64px;\n}\n\n.wrapIcon {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `sWzg3ezL4sh_FHaP8dHq`,
	"input": `bisPJ0cbjlfv70vIBtVW`,
	"wrapIcon": `u8QAxd9cwMIXBmzZv9Zz`
};
export default ___CSS_LOADER_EXPORT___;
